export default "__VITE_ASSET__BqrMmBdV__"